import React, { useEffect, useRef, useState } from 'react';

export default function Compteur({ valeur, duree = 900, className = '', testid }) {
  const [v, setV] = useState(0);
  const depart = useRef(0);
  useEffect(() => {
    const de = depart.current;
    const t0 = performance.now();
    let raf;
    const pas = (t) => {
      const p = Math.min(1, (t - t0) / duree);
      const x = Math.round(de + (valeur - de) * (1 - (1 - p) ** 3));
      setV(x);
      if (p < 1) raf = requestAnimationFrame(pas); else depart.current = valeur;
    };
    raf = requestAnimationFrame(pas);
    return () => cancelAnimationFrame(raf);
  }, [valeur, duree]);
  return <span className={`tabular-nums ${className}`} data-testid={testid}>{v.toLocaleString('fr-FR')}</span>;
}
